<script lang="ts">
    import { formatISODuration } from '~/utils/datetime';
    import MetaTags from '@amp/web-app-components/src/components/MetaTags/MetaTags.svelte';
    import type { Page } from '~/jet/models';
    import { getLocale } from '@amp/web-app-components/src/utils/internal/locale';
    import { getPageDir } from '@amp/web-apps-localization/src';
    import { DEFAULT_ORIGIN } from '~/utils/launch-utils';
    import { getI18n } from '~/stores/i18n';

    export let page: Page;

    const i18n = getI18n();
    const locale = getLocale();

    // Provide default title for pages not yet set up with SEO data
    $: defaultTitle = $i18n.t('ASE.Web.MusicClassical.Meta.Common.PageTitle');
    $: seoData = page.seoData;
    $: pageDir = getPageDir(locale.language) ?? 'ltr';
</script>

<MetaTags {seoData} {locale} {pageDir} origin={DEFAULT_ORIGIN} {defaultTitle}>
    <svelte:fragment slot="extendedOpenGraphData">
        {#if seoData?.songsCount}
            <meta
                property="music:song_count"
                content={seoData.songsCount.toString()}
            />
        {/if}

        {#if seoData?.ogSongs}
            {#each seoData.ogSongs as song, idx}
                <!-- TODO: Re-enable when we work on rdar://135711189 ([Classical on Web] SEO | Song/Track Page) -->
                <!--
                {#if song.attributes.url}
                    {@const songCanonicalUrl = getSongCanonicalURL(
                        song.attributes.url,
                    )}
                    <meta
                        property="music:song"
                        content={songCanonicalUrl}
                    />
                    <meta
                        property="music:song:preview_url:secure_url"
                        content={songCanonicalUrl}
                    />
                {/if}
                -->

                {#if song.duration}
                    <meta
                        property="music:song:duration"
                        content={song.duration}
                    />
                {/if}

                <meta property="music:song:track" content={`${idx + 1}`} />

                <!-- TODO rdar://135711189 ([Classical on Web] SEO | Song/Track Page - Handle ?i query param) -->
                <!-- music:album only gets displayed for selected song URLs -->
                <!-- {#if seoData.ogType === 'music.song'}
                    {#if song?.url}
                        <meta
                            property="music:album"
                            content={song.url}
                        />
                    {/if}

                    {#if song?.trackNumber}
                        <meta
                            property="music:album:track"
                            content={song.trackNumber}
                        />
                    {/if}
                {/if} -->
            {/each}
        {/if}

        {#if seoData?.artistUrls}
            {#each seoData.artistUrls as artistUrl}
                <meta property="music:musician" content={artistUrl} />
            {/each}
        {/if}

        {#if seoData?.musicReleaseDate}
            <meta
                property="music:release_date"
                content={seoData.musicReleaseDate}
            />
        {/if}
    </svelte:fragment>
</MetaTags>
